module.exports = __webpack_public_path__ + "static/img/review.32bfa37.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/review.png
// module id = wm26
// module chunks = 1